
/**
 * 穿梭框
 * 
 */


const SgiTransferEO = function () {

    return {
        insName: "",//绑定实例名
        _key: "", //key值
        width: "",
        height: "",
        showSearch: "",//是否显示搜索框
        leftTitle: "Source",//左标题
        rightTitle: "Target",//右标题
        leftOperation: "",//左操作文案
        rightOperation: "",//右操作文案
        // ctlH: "",
        // ctlW: "",
        desId: "EP_EO_UI_3017",
        c:'',//
        ctlN: "穿梭框",
        cId:'',//组件编号
        // sc:'',//语义代码
        n: "穿梭框",
        // t: "text",
        te: "我是穿梭框组件x",
        
    }

}

export { SgiTransferEO };
export default SgiTransferEO;


// WEBPACK FOOTER //
// ./~/rt-sd-common/sgiCompEO/SgiTransferEO.js